// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const pa: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'ਕਿਵੇਂ ਖੇਡਣਾ ਹੈ',
  'howto.pieces.heading': 'ਟੁਕੜੇ',
  'howto.pieces.source': 'ਸਰੋਤ',
  'howto.pieces.mirror': 'ਸ਼ੀਸ਼ਾ',
  'howto.pieces.switch': 'ਸਵਿੱਚ',
  'howto.pieces.exit': 'ਬਾਹਰ',
  'howto.pieces.wall': 'ਕੰਧ',
  'howto.controls.heading': 'ਕੰਟਰੋਲ',
  'howto.controls.clickSlot.line1': 'ਜਗ੍ਹਾ ਉੱਤੇ ਕਲਿੱਕ ਕਰੋ',
  'howto.controls.clickSlot.line2': 'ਸ਼ੀਸ਼ਾ ਰੱਖੋ',
  'howto.controls.dragMirror.line1': 'ਸ਼ੀਸ਼ਾ ਖਿੱਚੋ',
  'howto.controls.dragMirror.line2': 'ਘੁਮਾਓ',
  'howto.controls.rightClick.line1': 'ਸੱਜਾ-ਕਲਿੱਕ',
  'howto.controls.rightClick.line2': 'ਸ਼ੀਸ਼ਾ ਹਟਾਓ',
  'howto.controls.hint': 'ਮਾਊਸ ਵ੍ਹੀਲ: 1° ਦੀ ਬਰੀਕ ਘੁੰਮਾਈ।   ਸ਼ੀਸ਼ੇ ਉੱਤੇ ਟੈਪ: 15° ਦੀ ਘੁੰਮਾਈ।',
  'howto.objective.line1': 'ਹਰ ਸਵਿੱਚ ਨੂੰ ਜਗਾਓ — ਬਾਹਰ ਦਾ ਤਾਲਾ ਖੁੱਲ੍ਹ ਜਾਂਦਾ ਹੈ।',
  'howto.objective.line2': 'ਫਿਰ ਬਾਹਰ ਉੱਤੇ ਕਲਿੱਕ ਕਰੋ। ਜਿੰਨੇ ਘੱਟ ਸ਼ੀਸ਼ਿਆਂ ਨਾਲ ਹੋ ਸਕੇ, ਹੱਲ ਕਰੋ।',

  'howtoColor.title': 'ਰੰਗ ਅਤੇ ਪ੍ਰਿਜ਼ਮ',
  'howtoColor.pieces.heading': 'ਨਵੇਂ ਟੁਕੜੇ',
  'howtoColor.pieces.prism': 'ਪ੍ਰਿਜ਼ਮ',
  'howtoColor.pieces.redSwitch': 'ਲਾਲ ਸਵਿੱਚ',
  'howtoColor.pieces.yellowSwitch': 'ਪੀਲਾ ਸਵਿੱਚ',
  'howtoColor.pieces.whiteSwitch': 'ਚਿੱਟਾ ਸਵਿੱਚ',
  'howtoColor.how.heading': 'ਇਹ ਕਿਵੇਂ ਕੰਮ ਕਰਦੇ ਹਨ',
  'howtoColor.how.line1': 'ਇੱਕ ਚਿੱਟੀ ਕਿਰਨ ਲਾਲ, ਹਰੀ ਅਤੇ ਨੀਲੀ ਰੌਸ਼ਨੀ ਇਕੱਠੀ ਚੁੱਕਦੀ ਹੈ।',
  'howtoColor.how.line2':
    'ਪ੍ਰਿਜ਼ਮ ਚਿੱਟੀ ਰੌਸ਼ਨੀ ਨੂੰ ਆਪਣੀਆਂ ਤਿੰਨ ਬਾਹੀਆਂ ਉੱਤੇ ਤਿੰਨ ਰੰਗੀਨ ਕਿਰਨਾਂ ਵਿੱਚ ਵੰਡਦਾ ਹੈ।',
  'howtoColor.how.line3': 'ਰੱਖੇ ਪ੍ਰਿਜ਼ਮ ਉੱਤੇ ਕਲਿੱਕ ਕਰਕੇ ਉਸ ਦਾ ਇਨਪੁਟ-ਮੁਖ ਘੁਮਾਓ।',
  'howtoColor.switches.line1':
    'ਸਵਿੱਚਾਂ ਉੱਤੇ ਰੰਗੀਨ ਬਿੰਦੀਆਂ ਦਿਖਦੀਆਂ ਹਨ — ਉਹੀ ਰੰਗ ਉਨ੍ਹਾਂ ਨੂੰ ਚਾਹੀਦਾ ਹੈ।',
  'howtoColor.switches.line2': 'ਪੀਲੇ ਸਵਿੱਚ (ਲਾਲ + ਹਰੀਆਂ ਬਿੰਦੀਆਂ) ਨੂੰ ਦੋਵੇਂ ਰੰਗ ਇਕੱਠੇ ਚਾਹੀਦੇ ਹਨ।',
  'howtoColor.switches.line3': 'ਚਿੱਟੇ ਸਵਿੱਚ (ਤਿੰਨੇ ਰੰਗ) ਨੂੰ ਲਾਲ, ਹਰਾ ਅਤੇ ਨੀਲਾ ਇਕੱਠੇ ਚਾਹੀਦੇ ਹਨ।',

  'options.hints.label': 'ਬੁਝਾਰਤਾਂ ਵਿੱਚ ਸੁਝਾਅ-ਕੋਣ ਦਿਖਾਓ',
  'options.hints.help': 'ਹਰ ਪਰਾਵਰਤਨ ਉੱਤੇ ਆਉਂਦੀ ਅਤੇ ਪਰਾਵਰਤਿਤ ਕਿਰਨ ਵਿਚਲਾ ਕੋਣ ਦਿਖਾਉਂਦਾ ਹੈ।',

  'level.01-intro.title': 'ਹੈਲੋ ਰੌਸ਼ਨੀ',
  'level.02-two-mirrors.title': 'ਦੋ ਮੋੜ',
  'level.03-corner.title': 'ਰਾਹ ਵਿੱਚ ਕੰਧ',
  'level.04-two-targets.title': 'ਦੋ ਨਿਸ਼ਾਨੇ',
  'level.05-tight.title': 'ਤੰਗ',
  'level.06-hello-color.title': 'ਹੈਲੋ ਰੰਗ',
  'level.07-pick-a-side.title': 'ਇੱਕ ਪਾਸਾ ਚੁਣੋ',
  'level.08-yellow.title': 'ਪੀਲਾ',
  'level.09-magenta.title': 'ਮੈਜੈਂਟਾ',
  'level.10-spectrum.title': 'ਵਰਣਪਟ',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'ਸਮਕੋਣ',
  'puzzle.hint.angleType.acute': 'ਨਿਊਨ',
  'puzzle.hint.angleType.obtuse': 'ਅਧਿਕ',
  'puzzle.hint.label': '{angle}°\n{type}',
};
